import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContractForm } from 'pages/contracts/components/ContractForm';
import { IContractItem } from 'types/contracts';
import { useCreateContractMutation } from 'services/contracts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function CreateContractDialog({ isOpen, onClose }: Props) {
  const { t } = useTranslation()

  return (
    <Dialog fullWidth open={isOpen} onClose={onClose}>
      <DialogTitle>
        {t('create-contract')}
      </DialogTitle>
      <DialogContent>
        <ContractForm canEdit onCancel={onClose} />
      </DialogContent>
    </Dialog>
  )
}
